import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { WorkspaceService } from '../../service/workspace.service';

export const warehouseAccessGuard: CanActivateFn = () => {
  const workspace = inject(WorkspaceService);
  return workspace.canAccess('WAREHOUSE') ? true : inject(Router).createUrlTree(['/access-denied']);
};
